import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Truck, LogOut } from "lucide-react";

export const Header = ({ right }) => {
  const { user, logout } = useAuth();
  const roleLabel =
    user?.role === "admin" ? "Chauffeur" : user?.role === "restaurant" ? "Restaurant" : "Client";

  return (
    <header className="sticky top-0 z-40 border-b border-[#1F293D] bg-[#0c111c]/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#ff6a00] shadow-[0_0_20px_rgba(255,106,0,0.5)]">
            <Truck className="h-5 w-5 text-white" strokeWidth={2.5} />
          </div>
          <div className="leading-none">
            <div className="font-display text-lg font-extrabold tracking-tight text-white">
              CHAP<span className="text-[#ff6a00]">CHAP</span>
            </div>
            <div className="text-[10px] font-medium uppercase tracking-widest text-slate-500">
              Île-de-France
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {right}
          {user && (
            <>
              <span className="hidden rounded-full border border-[#1F293D] bg-[#151b2b] px-3 py-1 text-xs font-semibold text-slate-300 sm:inline">
                {roleLabel} · {user.name?.split(" ")[0] || user.email}
              </span>
              <button
                data-testid="logout-btn"
                onClick={logout}
                className="flex h-9 w-9 items-center justify-center rounded-lg border border-[#1F293D] bg-[#151b2b] text-slate-400 transition-colors hover:border-rose-500/40 hover:text-rose-400"
                title="Déconnexion"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
